import React from "react";
import { useTranslation } from "next-export-i18n";

import Footer from "@/src/layout/footers/footer";
import Header from "@/src/layout/headers/header";
import HeroArea from "./hero-area";
import AboutArea from "./about-area";

import platform_img_1 from "@assets/img/platform/audience-reach-awareness.png";
import platform_img_2 from "@assets/img/platform/engagement-retargeting.svg";
import platform_img_3 from "@assets/img/platform/tracking-performance.svg";
import platform_img_4 from "@assets/img/platform/demographic-targeting.svg";

import video_img_1 from "@assets/img/platform/Opening-New-Campaign.png";
import video_img_2 from "@assets/img/platform/Hyper-Local-Campaign.png";
import video_img_3 from "@assets/img/platform/Campaign-Planning-Platform-Discovery.png";
import video_img_4 from "@assets/img/platform/Campaign-Planning-Audience-Demographics.png";
import video_img_5 from "@assets/img/platform/Camapign-Reports.png";
import video_img_6 from "@assets/img/platform/Clicks-report.png";

const Platform = () => {
    const { t } = useTranslation();

    const videosData = [
        {
            id: 1,
            title: t("platform.videos.video_1.title"),
            image: video_img_1,
            videoLink: "https://www.youtube.com/watch?v=djhd2snujjE",
            description: t("platform.videos.video_1.description"),
        },
        {
            id: 2,
            title: t("platform.videos.video_2.title"),
            image: video_img_2,
            videoLink: "https://www.youtube.com/watch?v=ll2ESepg86o",
            description: t("platform.videos.video_2.description"),
            highlight: t("platform.videos.video_2.highlight"),
        },
        {
            id: 3,
            title: t("platform.videos.video_3.title"),
            image: video_img_3,
            videoLink: "https://www.youtube.com/watch?v=vt3aQFssyqc",
            description: t("platform.videos.video_3.description"),
            highlight: t("platform.videos.video_3.highlight"),
        },
        {
            id: 4,
            title: t("platform.videos.video_4.title"),
            image: video_img_4,
            videoLink: "https://www.youtube.com/watch?v=WegmyyhrE_I",
            description: t("platform.videos.video_4.description"),
            highlight: t("platform.videos.video_4.highlight"),
        },
        {
            id: 5,
            title: t("platform.videos.video_5.title"),
            image: video_img_5,
            videoLink: "https://www.youtube.com/watch?v=m0u9qqeaCSw",
            description: t("platform.videos.video_5.description"),
            highlight: t("platform.videos.video_5.highlight"),
        },
        {
            id: 6,
            title: t("platform.videos.video_6.title"),
            image: video_img_6,
            videoLink: "https://www.youtube.com/watch?v=Fhb0IH-OaIQ",
            description: t("platform.videos.video_6.description"),
            highlight: t("platform.videos.video_6.highlight"),
        },
    ];

    return (
        <>
            <Header />
            <main>
                <HeroArea />
                <AboutArea
                    id={1}
                    type="image_last"
                    title={{
                        primary: t("platform.blocks.block_1.title.part_1"),
                        secondary: t("platform.blocks.block_1.title.part_2"),
                    }}
                    description={t("platform.blocks.block_1.description")}
                    items={[
                        t("platform.blocks.block_1.items.item_1"),
                        t("platform.blocks.block_1.items.item_2"),
                        t("platform.blocks.block_1.items.item_3"),
                    ]}
                    image={platform_img_1}
                    videoData={[videosData[1]]}
                />
                <AboutArea
                    id={2}
                    type="image_first"
                    title={{
                        primary: t("platform.blocks.block_2.title.part_1"),
                        secondary: t("platform.blocks.block_2.title.part_2"),
                    }}
                    description={t("platform.blocks.block_2.description")}
                    items={[
                        t("platform.blocks.block_2.items.item_1"),
                        t("platform.blocks.block_2.items.item_2"),
                        t("platform.blocks.block_2.items.item_3"),
                    ]}
                    image={platform_img_2}
                    videoData={[videosData[2]]}
                />
                <AboutArea
                    id={3}
                    type="image_last"
                    title={{
                        primary: t("platform.blocks.block_3.title.part_1"),
                        secondary: t("platform.blocks.block_3.title.part_2"),
                    }}
                    description={t("platform.blocks.block_3.description")}
                    items={[
                        t("platform.blocks.block_3.items.item_1"),
                        t("platform.blocks.block_3.items.item_2"),
                        t("platform.blocks.block_3.items.item_3"),
                    ]}
                    image={platform_img_3}
                    videoData={[videosData[4], videosData[5]]}
                />
                <AboutArea
                    id={4}
                    type="image_first"
                    title={{
                        primary: t("platform.blocks.block_4.title.part_1"),
                        secondary: t("platform.blocks.block_4.title.part_2"),
                    }}
                    description={t("platform.blocks.block_4.description")}
                    items={[
                        t("platform.blocks.block_4.items.item_1"),
                        t("platform.blocks.block_4.items.item_2"),
                        t("platform.blocks.block_4.items.item_3"),
                    ]}
                    image={platform_img_4}
                    videoData={[videosData[3]]}
                />
            </main>
            <Footer />
        </>
    );
};

export default Platform;
